import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=ae64d7ce&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.vue?vue&type=style&index=0&id=ae64d7ce&scoped=true&lang=css&"
import style1 from "./Controls.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae64d7ce",
  null
  
)

export default component.exports